<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable" @checkbox="checkbox"  @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>
    <dialog-table-page ref="tradeTable"  :pageData="tradePageData"></dialog-table-page>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import FORM from '@/components/page/form.vue'
  import UPDATE from '@/components/page/update.vue'
  import Url from '@/views/crs36/util/url'
  import Qs from 'qs'
  import DateUtil from '@/utils/IM/tradeDataUtil.js'
  import dialogTablePage from '@/components/page/dialogTable.vue'
  let status = {1:"待审批",2:"已审批",3:"已发放"}
  export default {
    name: 'list',
    components: {
      tablePage,
      FORM,
      UPDATE,
      dialogTablePage
    },
    methods: {
      checkbox(row){
        this.applyId = row.map(key => key.id).join(",");
      },
      /*表格按钮点击事件*/
      bthClick (clickName, row) {
        if (clickName == "update"){
          this.$refs.childUpdate.open(row);
        }else if(clickName == "trade"){
          this.tradePageData.sync = true;
          this.$refs.tradeTable.defaultQueryData(row);
        } else if(clickName == "apply"){
          this.dataChanage(Url.commission.day.apply,{ids:row.id},res => {
            if (res.code == 0) {
              this.$message.success("suc");
              this.$refs.childTable.defaultGetData(this.queryData);
            } else {
              this.$message.error(res.message);
            }
          })
        }else if(clickName == "handAddBonus"){
          this.dataChanage(Url.commission.day.handAddBonus,{id:row.id},res => {
            if (res.code == 0) {
              this.$message.success("suc");
              this.$refs.childTable.defaultGetData(this.queryData);
            } else {
              this.$message.error(res.message);
            }
          })
        }
      },
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        if("查询" == clickName){
          this.queryData = data;
          this.$refs.childTable.defaultGetData(data);
        }else if("批量审批" == clickName){
          this.dataChanage(Url.commission.day.apply,{ids:this.applyId},res => {
            if (res.code == 0) {
              this.$message.success("suc");
              this.$refs.childTable.defaultGetData(this.queryData);
            } else {
              this.$message.error(res.message);
            }
          })
        }
      },
      /*新增或跟提交数据触发事件*/
      submit(model){
        //根据是否包含id更新还是添加
        this.dataChanage(Url.commission.day.updateAmount,model,res => {
          if (res.code == 0){
            this.$refs.childUpdate.close();
            this.$message.success("suc");
          }else{
            this.$message.error(res.message);
          }
          this.$refs.childTable.defaultGetData(this.queryData);
      })
      },
      dataChanage(url,option,suc,fail){
        this.axios.post(url, Qs.stringify(option || {})).then(res => {
        if(suc && (typeof suc == 'function')) suc(res);
      }).catch(res => {
          if(fail && (typeof fail == 'function')) fail(res);
      })
      }
    },
    data () {
      return {
        applyId:"",
        queryData:{},
        /*新增或更新*/
        updateData:{
          cols:[
              { title: 'id', field: 'id',hidden: true},
              { title: '实际返现金额', field: 'realAmount'},
          ]
        },
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[
              {click:"查询",auth:"crs36.commission.day.query"},
              {click:"批量审批",confirm:true,auth:"crs36.commission.day.apply"},
          ]
        },
        /*table生成*/
        pageData: {
          queryUrl: Url.commission.day.query, //请求路径和参数
          selection: true,
          sequence: true,
          cols: [
              { title: '活动id', field: 'activeId'},
              { title: '用户账号', field: 'account'},
              { title: '层级id', field: 'levelId'},
              { title: '层级名称', field: 'name'},
              { title: '状态', field: 'status',render:(data,full)=>{
                return status[data];
                }},
              { title: '交易手数', field: 'total',h5Click:"trade"},
              { title: '返现金额', field: 'amount'},
              { title: '实际返现金额', field: 'realAmount'},
              { title: '用户参与时间', field: 'startTime',render:(data,full)=>{
                  return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                }},
              { title: '活动结束时间', field: 'endTime',render:(data,full)=>{
                  return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                }},
              { title: '审批人', field: 'approval'},
              { title: '审批时间', field: 'approvalTime',render:(data,full)=>{
                  return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                }},
              { title: '实际金额修改人', field: 'realer'},
              { title: '实际金额修改时间', field: 'realTime',render:(data,full)=>{
                  return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                }},
              { title: '更新时间', field: 'updateTime',render:(data,full)=>{
                  return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                }},

              {title: window.$t('crs36.bt.operation'),width: 300,btnClick:[
                {name: "审批",click:"apply",type:"primary",icon:"el-icon-edit",confirm:true,hidden:(data,full)=>{
                    return full.status != 1;
                  },auth:"crs36.commission.day.apply"},
                {name: "修改实际金额",click:"update",type:"primary",icon:"el-icon-edit",hidden:(data,full)=>{
                    return full.status != 1;
                  },auth:"crs36.commission.day.update"},
                {name: "重新发放",click:"handAddBonus",type:"primary",icon:"el-icon-edit",confirm:true,hidden:(data,full)=>{
                    return full.status != 2;
                  },auth:"crs36.commission.day.handAddBonus"},
              ]
            },
          ]
        },
        tradePageData: {
          queryUrl: Url.commission.trade.query, //请求路径和参数
          sequence: true,
          sync: false,
          cols: [
            { title: '用户账号', field: 'account'},
            { title: '同步数据id', field: 'synId'},
            { title: 'positionId', field: 'positionId'},
            { title: '交易产品', field: 'symbol'},
            { title: '手数', field: 'volume'},
            { title: '佣金', field: 'commission'},
            { title: '交易平台', field: 'platform'},
            { title: '日期（天）', field: 'day'},
            { title: '交易时间', field: 'time',render:(data,full)=>{
                return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
              }},
          ]
        }
      }
    }
  }
</script>
